import { render, staticRenderFns } from "./backsearch-create.vue?vue&type=template&id=00abcd36&scoped=true"
import script from "./backsearch-create.vue?vue&type=script&lang=js"
export * from "./backsearch-create.vue?vue&type=script&lang=js"
import style0 from "./backsearch-create.vue?vue&type=style&index=0&id=00abcd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00abcd36",
  null
  
)

export default component.exports